/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SendingInputs */

const en_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const de_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden…`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {SendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sending = /** @type {((inputs?: SendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sending(inputs)
	return de_sending(inputs)
});